"use client";

import { faArrowRight, FontAwesomeIcon } from "@/constants/icons";
import { CategoryData } from "@/services/dataTypes";
import Link from "next/link";
import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

interface Props {
  categories: CategoryData[];
  pageSlug: string;
  categoryName?: string;
}

const CategorySidebarProduct = ({
  categories,
  pageSlug,
  categoryName,
}: Props) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const displayedCategories = isExpanded
    ? categories?.slice(0, 10)
    : categories?.slice(0, 5);

  return (
    <div className="category-sidebar bg-[#FAFAFA]/50 p-6 rounded-[2rem] border border-[#E2E8F0]">
      <h4 className="text-base font-black text-[#0F172A] mb-6 flex items-center gap-3 uppercase tracking-wider">
        <div className="w-1 h-6 bg-[#3730A3] rounded-full shadow-sm shadow-[#3730A3]/20"></div>
        {categoryName ? `Related to ${categoryName}` : `Suggested Hubs`}
      </h4>

      {/* List Container */}
      <div className="grid gap-2">
        {displayedCategories?.map((category, i) => (
          <Link
            key={i}
            href={`/${pageSlug}/${category.url}`}
            className="group no-underline flex items-center justify-between p-3.5 rounded-xl transition-all duration-300 border border-transparent hover:border-[#3730A3]/20 hover:bg-white hover:shadow-md active:scale-[0.98]"
          >
            <div className="flex items-center gap-3">
              <div className="w-2 h-2 rounded-full bg-[#E2E8F0] group-hover:bg-[#3730A3] group-hover:scale-125 transition-all duration-300"></div>
              <span className="text-sm font-bold text-[#64748B] group-hover:text-[#0F172A] transition-colors">
                {category?.name}
              </span>
            </div>
          </Link>
        ))}
      </div>

      {categories?.length > 5 && (
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="w-full mt-4 py-3 flex items-center justify-center gap-2 text-[11px] font-black uppercase tracking-widest text-indigo-800 border-t border-[#E2E8F0] hover:text-[#0F172A] transition-colors duration-300"
        >
          {isExpanded ? (
            <>
              Show Less <ChevronUp size={14} />
            </>
          ) : (
            <>
              Show More <ChevronDown size={14} />
            </>
          )}
        </button>
      )}
    </div>
  );
};

export default CategorySidebarProduct;
